<template>
  <div>
    <v-row v-if="tableDisplay == 'users'">
      <v-col cols="12" style="margin-top: -80px">
        <v-row>
          <v-col cols="12" class="text-right">
            <v-btn
              color="primary"
              dark
              rounded
              small
              class="mx-2"
              @click="userDialog = true"
            >
              Create User
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              dark
              rounded
              small
              class="mx-2"
              @click="bulkUserUpload = true"
            >
              Import Users
              <v-icon>mdi-upload</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row class="mb-4 px-3 mt-n2" v-if="selected.length > 0">
          <v-app-bar color="grey darken-3" dense dark>
            <v-toolbar-title class="overline"
              >{{ selected.length }} selected</v-toolbar-title
            >
            <v-divider class="mx-4" vertical></v-divider>
            <v-btn
              depressed
              class="overline mx-4 custom-hover"
              color="grey darken-3"
              @click="editUser"
              >Update</v-btn
            >
            <v-btn
              depressed
              class="overline mx-4 custom-hover"
              color="grey darken-3"
              @click="archiveUser()"
              >Delete</v-btn
            >
          </v-app-bar>
        </v-row>
      </v-col>
      <v-col cols="12" class="mt-n8" v-show="showSuccessMessage">
        <v-alert dense text type="success" dismissible
          >Created new user</v-alert
        >
      </v-col>
      <v-col cols="12" class="mt-n8" v-show="showSuccess">
        <v-alert dense text type="success" dismissible>Updated user</v-alert>
      </v-col>
      <v-col>
        <v-data-table
          v-model="selected"
          :single-select="false"
          :headers="headers"
          :items="allUsers"
          :items-per-page="10"
          class="elevation-2 mt-n6"
          item-key="id"
          :search="search"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          show-expand
          show-select
          :loading="isFetching"
          loading-text="Loading... Please wait"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    More info about <b>{{ item.name }}...</b>
                  </v-col>
                  <v-col cols="12" class="pt-0">
                    <b>Email:</b> {{ item.email }}
                  </v-col>
                  <v-col cols="6">
                    Offices Assigned To:
                    <br />
                    <ul id="example-1">
                      <li v-for="office in item.offices" :key="office.id">
                        {{ office.name }}
                      </li>
                    </ul>
                  </v-col>
                  <v-col cols="6">
                    Position/s:
                    <br />
                    <ul id="example-1">
                      <li v-for="position in item.positions" :key="position.id">
                        {{ position.name }}
                      </li>
                    </ul>
                  </v-col>
                  <v-col cols="12">
                    Permissions/s:
                    <br />
                    <ul id="example-1">
                      <li
                        v-for="permission in item.permissions"
                        :key="permission.id"
                      >
                        {{ permission.name }}
                      </li>
                    </ul>
                  </v-col>
                </v-row>
              </v-container>
            </td>
          </template>
        </v-data-table>
      </v-col>

      <v-snackbar v-model="snackbar" :timeout="timeout">
        "Must select only one user to update details"
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>

      <UserCreateModal
        :dialog="userDialog"
        :updateUser="selectedUser"
        @closeDialog="closeUserDialog"
      />
      <BulkUserUpload
        :show="bulkUserUpload"
        :card_title="import_user_card"
        @closeDialog="closeBulkUpload"
        :action_for="action_for"
      />
    </v-row>
    <loading-overlay v-if="loading" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UserCreateModal from "../UserCreateModal";
import BulkUserUpload from "../imports/ImportModal";
import Swal from "sweetalert2";
import LoadingOverlay from "../common/LoadingOverlay.vue";

export default {
  name: "UserTable",
  props: {
    tableDisplay: String,
    search: String,
    isFetching: Boolean,
  },
  components: {
    UserCreateModal,
    BulkUserUpload,
    LoadingOverlay,
  },
  data() {
    return {
      loading: false,
      selected: [],
      singleSelect: false,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Email", value: "email" },
        { text: "Date Created", value: "date" },
      ],
      options: {
        page: 1,
        itemsPerPage: 0,
      },
      expanded: [],
      singleExpand: false,
      userDialog: false,
      selectedUser: null,
      showSuccess: false,
      showSuccessMessage: false,
      snackbar: false,
      timeout: 5000,
      bulkUserUpload: false,
      import_user_card: "Import Users",
      action_for: "user_imports",
      isUpdate: null,
    };
  },
  methods: {
    ...mapActions(["fetchUsers", "deleteUser"]),
    bulkUpload() {
      if (!this.bulkUserUpload) this.bulkUserUpload = true;
      else this.bulkUserUpload = false;
    },
    editUser() {
      if (this.selected.length > 1) {
        this.snackbar = true;
      } else {
        this.userDialog = true;
        this.selectedUser = this.selected[0];
      }
    },
    closeBulkUpload(val) {
      if (!val) this.bulkUserUpload = false;
    },
    closeUserDialog(val, isUpdate) {
      if (isUpdate !== "close") {
        if (isUpdate) {
          this.showSuccess = true;
          this.showSuccessMessage = false;
        } else {
          this.showSuccess = false;
          this.showSuccessMessage = true;
        }
      } else {
        this.showSuccess = false;
        this.showSuccessMessage = false;
      }
      if (!val) {
        this.userDialog = false;
        this.selectedUser = null;
      } else {
        this.userDialog = false;
        this.selectedUser = null;
        this.selected = [];
      }
    },
    archiveUser() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      }).then((result) => {
        const selectedItems = [];
        for (let i = 0; i < this.selected.length; i++) {
          selectedItems.push(this.selected[i].id);
        }
        if (result.isConfirmed) {
          this.loading = true;
          this.deleteUser(selectedItems).then(() => {
            this.loading = false;
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
            this.selected = [];
          });
        }
      });
    },
  },
  computed: {
    ...mapGetters(["allUsers", "totalUserCount"]),
  },
};
</script>

<style></style>
